module.exports = __webpack_public_path__ + "static/img/merchant_case_2.b5661ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_case_2.png
// module id = GQF8
// module chunks = 8